// extracted by mini-css-extract-plugin
export default {"dietaryBlock":"dietary_dietaryBlock__2L1u0"};